import type { articles as pt } from '../pt/articles';
// English mirror of ../pt/articles.ts (shape checked against its pt twin).
export const articles: typeof pt = {
  title: 'Scientific Output',
  sub: {
    main: 'CIIMAR articles (Scopus)',
    scopusTotal: '{n} on Scopus',
    synced: 'synced {date}',
  },
  source: {
    rest: 'Scopus (Elsevier)',
    stub: 'Not configured',
    none: 'No connection',
  },
  stub: {
    intro: 'The Scopus/Elsevier API is not yet configured in this environment. Set the',
    and: 'and',
    outro: 'keys to fetch the articles.',
  },
  sync: {
    button: 'Sync',
    progress: 'Syncing… {done}',
    progressTotal: 'Syncing… {done}/{total}',
    failed: 'Sync failed: {error}',
  },
  filters: {
    searchPlaceholder: 'Search by title, author, journal or DOI…',
    allTeams: 'All teams',
    allResearchers: 'All researchers',
    allYears: 'All years',
    allMonths: 'All months',
    allTypes: 'All types',
    allQuartiles: 'All quartiles',
    openAccess: 'Open access',
    cited: 'With citations',
    clear: 'Clear',
  },
  loading: 'Loading…',
  loadingMore: 'Loading more…',
  empty: {
    filtered: 'No article matches the filters.',
    none: 'No articles.',
  },
  count: {
    one: '{n} article',
    many: '{n} articles',
  },
  card: {
    volume: 'vol. {n}',
    ciimarAuthors: 'CIIMAR researchers',
    quartileTip: 'Journal in {q}',
    quartileTipPercentile: 'Journal in {q} · CiteScore percentile {p}',
    openAccess: 'Open access',
    citationsTip: 'Citations (Scopus)',
    citationOne: 'citation',
    citationMany: 'citations',
  },
};
